import { render, staticRenderFns } from "./renovate.vue?vue&type=template&id=4de6f860&scoped=true&"
import script from "./renovate.vue?vue&type=script&lang=js&"
export * from "./renovate.vue?vue&type=script&lang=js&"
import style0 from "./renovate.vue?vue&type=style&index=0&id=4de6f860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de6f860",
  null
  
)

export default component.exports